import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import {
    Grid2 as Grid,
    DialogTitle,
    DialogContent,
    Tooltip,
    ButtonGroup,
    TextField,
    Box
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';



import { AddCircle, RemoveCircle, Save, Add, Edit, Delete } from '@mui/icons-material';

import { useSearchParams } from 'react-router-dom';
import { makeid, myTimestampToDate } from '../utils/ui_utils';
import { LoadingButton } from '@mui/lab';
import { useAuth } from '../core/AuthProvider';
import { add_match_complete_template, edit_match_complete_template } from '../FirebaseUtils/dbSettings';
import { MatchDialog } from './MatchDialog';
import DeleteconfirmationSection from '../components/DeleteConfirmationSection';
import { globalstyles } from '../lib/definitions';


const newtemplate_match_complete = {
    name: '',
    value: []
}




export const TemplateMatch_completeDialog = forwardRef(({ event_id, reloadFn }, ref) => {
    const { user } = useAuth()
    const dialogRef = useRef()
    const childRefDelete = useRef()
    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newtemplate_match_complete })
    const [isEdited, setIsEdited] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [isInvalid, setIsInvalid] = useState(false)
    const [is_new, setIsNew] = useState(false)
    const [index, setIndex] = useState(-1)
    const [searchParams, setSearchParams] = useSearchParams()






    useImperativeHandle(ref, () => {
        return {
            onNew() {
                setCurElement({ ...newtemplate_match_complete, template_match_complete_code: makeid(8, true) })
                setIndex(-1)
                setIsNew(true)
                setIsEdited(false)
                setOpen(true);
            },
            onEdit(el, i, is_c) {
                console.log("IS CURRENT", is_c)
                setOpen(true);
                setIsNew(false)
                let _el = { ...newtemplate_match_complete, ...el }
                setCurElement(_el)
                setIndex(i)
                setIsEdited(false)
            }
        }
    })


    const handleClose = () => {
        setSearchParams({})
        setOpen(false);
    };


    const handleSave = () => {
        if (is_new) {
            add_match_complete_template(user.uid, curElement)
            reloadFn()
        } else {
            edit_match_complete_template(user.uid, curElement.id, curElement)
            reloadFn(curElement)
        }
        setOpen(false)
    }



    const onChangeHandler = (el, level) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        if (type === 'radio') {
            if (value === 'true') {
                value = true
            } else if (value === 'false') {
                value = false
            }
        } else if (type === 'checkbox') {
            value = el.checked

        }
        if (value !== undefined) {
            setCurElement({ ...curElement, [name]: value })
            setIsEdited(true)
        }
    }


    const addFn = (c) => {
        setCurElement(e => {
            let c_list = [...e.match_complete_list]
            c_list.push(c)
            return { ...e, match_complete_list: c_list }
        })
        setIsEdited(true)

    }

    const editFn = (c, i) => {
        setCurElement(e => {
            let c_list = [...e.match_complete_list]
            c_list.splice(i, 1, c)
            return { ...e, match_complete_list: c_list }
        })
        setIsEdited(true)

    }
    const handleNew = () => {
        dialogRef.current.onNew()
    }

    const handleEdit = (r, i) => {
        dialogRef.current.onEdit(r, i)
    }

    const handleDelete = (r, i) => {
        const cb = () => {
            setCurElement(e => {
                let c_list = [...e.match_complete_list]
                c_list.splice(i, 1)
                return { ...e, match_complete_list: c_list }

            })
        }
        childRefDelete.current.confirmDelete('Cancella gara', `Sei sicuro di voler cancellare la gara: <b>${r.match_complete_name}</b>`, cb)
    }



    useEffect(() => {
        return () => {

        }

    }, [])



    return (
        <div>

            <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth={true}>
                <DeleteconfirmationSection ref={childRefDelete} />
                <MatchDialog ref={dialogRef} reloadFn={reloadFn} addFn={addFn} editFn={editFn} />
                <DialogTitle>
                    Template gara :  {curElement.template_match_complete_name}
                </DialogTitle>
                <DialogContent>
                    <TextField
                        margin="dense"
                        id="name"
                        label={'Nome template'}
                        fullWidth
                        name="name"
                        variant="standard"
                        value={curElement.name}
                        onChange={(ev) => onChangeHandler(ev.target)}
                    />
                    <Grid container spacing={2} sx={{ background: 'lightblue', p: 0.5, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                        <Grid size={2} sx={{ fontSize: '1.2em', fontWeight: 'bold' }}>
                            Lista categorie
                        </Grid>
                        <Grid size={"auto"}>

                        </Grid>
                    </Grid>
                    <Grid container sx={{ backgroundColor: 'lightgrey' }}>
                        <Grid size="grow">
                            nome
                            <Box style={{ fontSize: '0.7em' }}>descrizione</Box>
                        </Grid>
                        <Grid size="grow">
                            ora inizio previsto
                            <Box style={{ fontSize: '0.7em' }}>inizio-fine (reali)</Box>
                        </Grid>
                        <Grid size="grow">
                            premi
                            <Box style={{ fontSize: '0.7em' }}>Tipolgia - Nome - filtri - punteggi</Box>
                        </Grid>
                        <Grid size={1}>
                            etichette posizioni
                        </Grid>
                        <Grid size="grow">
                            soggetti
                        </Grid>
                        <Grid size={2} sx={{ textAlign: 'right' }}>
                            <Button onClick={handleNew} variant="contained" size="small" startIcon={<Add />}>nuova gara</Button>
                        </Grid>

                    </Grid>

                    <Grid >
                        {curElement.value.map((s, k) => (
                            <OneMatch_complete
                                key={k}
                                match_complete={s}
                                index={k}
                                handleEdit={handleEdit}
                                handleDelete={handleDelete}
                            />
                        ))}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} onClick={handleClose}>Chiudi</Button>
                    {isEdited &&
                        <LoadingButton key={'bs'} disabled={isInvalid} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary" loading={isSaving} loadingPosition="start">Salva</LoadingButton>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
})


const OneMatch_complete = ({ match_complete, index, handleDelete, handleEdit  }) => {
    useEffect(() => {

        const initData = async () => {

        }
        initData()


    }, [match_complete])





    return (
        <Grid container sx={{ ...globalstyles.elem_row, ...globalstyles.list_row, }}>

            <Grid size={"grow"}>
                <Grid size={"grow"} sx={{ fontWeight: 'bold' }}>
                    {match_complete.match_name}
                </Grid>
                <Grid size={"grow"} sx={{ fontSize: '0.8em' }}>
                    {match_complete.match_description}
                </Grid>
            </Grid>
            <Grid size={2} sx={{ textAlign: 'right' }}>
{/*                 <ButtonGroup size="small">
                    <Tooltip title="modifica">
                        <Button color="warning" onClick={() => handleEdit(match_complete, index)} startIcon={<Edit color="warning" />}></Button>
                    </Tooltip>
                    <Tooltip title="cancella">
                        <Button color="error" disabled={is_current} onClick={() => handleDelete(match_complete, index)} startIcon={<Delete />}></Button>
                    </Tooltip>
                </ButtonGroup> */}

            </Grid>
        </Grid>

    )
}